import { render } from "./FunRunSummaryView.vue?vue&type=template&id=60ce970d"
import script from "./FunRunSummaryView.vue?vue&type=script&lang=js"
export * from "./FunRunSummaryView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__